/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type GenerateInspectionReportInput = {
    inspectionId: string;
};
export type InspectionPanelGenerateReportMutationVariables = {
    input: GenerateInspectionReportInput;
};
export type InspectionPanelGenerateReportMutationResponse = {
    readonly generateInspectionReport: {
        readonly reportUrl: string;
        readonly inspection: {
            readonly id: string;
        };
    };
};
export type InspectionPanelGenerateReportMutation = {
    readonly response: InspectionPanelGenerateReportMutationResponse;
    readonly variables: InspectionPanelGenerateReportMutationVariables;
};



/*
mutation InspectionPanelGenerateReportMutation(
  $input: GenerateInspectionReportInput!
) {
  generateInspectionReport(input: $input) {
    reportUrl
    inspection {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateInspectionReportPayload",
    "kind": "LinkedField",
    "name": "generateInspectionReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PropertyInspection",
        "kind": "LinkedField",
        "name": "inspection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionPanelGenerateReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionPanelGenerateReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "16b5e6eb5a70af0d47836ac14b21ab5b",
    "id": null,
    "metadata": {},
    "name": "InspectionPanelGenerateReportMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionPanelGenerateReportMutation(\n  $input: GenerateInspectionReportInput!\n) {\n  generateInspectionReport(input: $input) {\n    reportUrl\n    inspection {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '98d601d063f5d2102a3fc95dd3f60037';
export default node;
